import { styled } from "@mui/material";

export const StyledForm = styled("form")({
  height: "100%",
});
